/**
 * @Author : DingHuiHui
 * @Content : 流程管理接口配置
 */
import $http from '@/utils/requestAxios'

export const apiProcess = {
  // 列表
  list (params, page = 1, size = 10000) {
    return $http.get('/processes', { ...params, page, size })
  },
  // 删除流程
  delete (id) {
    return $http.delete('/processes', { id })
  },
  // 修改流程状态
  updateStatus (id, status) {
    return $http.put('processes/status', { id, status })
  },
  // 上传
  upload (params) {
    return $http.post('/processes/verfile', params)
  },
  // 获取流程信息
  info (id) {
    return $http.get('/processes/singleton', { id })
  },
  // 修改流程信息
  update (params) {
    return $http.put('/processes', params)
  },
  // 修改流程调度状态
  schStatus (id, status) {
    return $http.put('/processes/scheduler/status', { id, status })
  },
  // 流程版本下载
  download  (id) {
    return $http.post('/processes/vers/download', { id }, { responseType: 'blob' })
  },
  // 临时任务
  temp (params) {
    return $http.post('/processes/schedulerTemp', params)
  },
  // 日历详情
  calendar (script, datemark, procid) {
    return $http.get('/processes/script', { script, datemark, procid })
  }
}

// 调度
export const apiSchedule = {
  // 检查表达式
  check (expression) {
    return $http.get('/processes/scheduler', { expression })
  },
  // 修改状态
  stateMod (id, status) {
    return $http.put('/processes/scheduler/status', { id, status })
  },
  // 生成调度表达式
  get (scheduleMode, scheduleCommand, scheduleTime) {
    return $http.post('/processes/scheduler/cronexpr', { scheduleMode, scheduleCommand, scheduleTime })
  }
}
